module.exports = "<div class=\"container\"><p>{{ 'LBL_FOOTER_TITLE' | translate }}</p></div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/footer.pug
// module id = 51
// module chunks = 0